import qs from "qs";
import axios from "axios";
import Cookies from "js-cookie";
import { URL, API_URL } from "../../../constants/Constants";

/**
 * Autentica un usuario en el sistema
 * @param {string} user - Nombre de usuario
 * @param {string} password - Contraseña del usuario
 * @returns {Promise<Object|false>} Datos del usuario autenticado o false si falla
 */
export const loginAuthenticate = async (user, password) => {
  const userData = {
    screen: "auth",
    action: "login",
    name: user,
    pass: password,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(userData));

    if (response.data.status === "ok") {
      Cookies.set("lang", response.data.data[0].lang);
      return response.data;
    } else {
      console.log("Autenticación fallida");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene la carga de trabajo de un usuario
 * @param {string} usuario - Nombre del usuario
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Array|false>} Carga de trabajo o false si hay error
 */
export const getWorkLoad = async (usuario, currentScreenId, typeConnect) => {
  const newTime = {
    usuario: usuario,
    query_type: currentScreenId,
    action: typeConnect,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Carga de trabajo correcta");
      return response.data.data;
    } else {
      console.log("Error en la carga de trabajo");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene el tiempo total trabajado hoy por un usuario
 * @param {string} usuario - Nombre del usuario
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Array|false>} Tiempos totales o false si hay error
 */
export const getTotalTimeToday = async (usuario, currentScreenId, typeConnect) => {
  const newTime = {
    usuario: usuario,
    query_type: currentScreenId,
    action: typeConnect,
    tiemposTotal: "consultaDeTiempos",
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Carga de tiempos correcta");
      return response.data.data;
    } else {
      console.log("Error en la tiempos de trabajo");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene usuarios del taller
 * @param {string} screenName - Nombre de la pantalla (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {number} currentScreenId - ID de la pantalla actual (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Array|false>} Lista de usuarios o false si hay error
 */
export const getUserTaller = async (screenName, typeConnect, currentScreenId) => {
  const newTime = {
    screen: "parts_movements",
    action: "query",
    movimiento: "consultaListaUsuarios",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("lista de usuarios correcta");
      return response.data.data;
    } else {
      console.log("Error al cargar lista de usuarios");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene trabajo de operadores
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @returns {Promise<Array|false>} Datos de trabajo de operadores o false si hay error
 */
export const getOperatorWork = async (currentScreenId, typeConnect) => {
  const newTime = {
    query_type: currentScreenId,
    action: typeConnect,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Carga de trabajo correcta");
      return response.data.data;
    } else {
      console.log("Error en la carga de trabajo");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene usuarios completos
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} userQuery - Consulta de usuario
 * @returns {Promise<Array|false>} Datos de usuarios completos o false si hay error
 */
export const getFullUsuarios = async (currentScreenId, typeConnect, userQuery) => {
  const newTime = {
    query_type: currentScreenId,
    action: typeConnect,
    userQuery: userQuery,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Carga de trabajo correcta");
      return response.data.data;
    } else {
      console.log("Error en la carga de trabajo");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Crea un nuevo usuario
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {Object} newUser - Datos del nuevo usuario
 * @returns {Promise<Object|false>} Datos del usuario creado o false si hay error
 */
export const createNewUser = async (currentScreenId, typeConnect, newUser) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
    ...newUser,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.error("Error al crear usuario:", response.data.message);
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Edita datos de un usuario
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {Object} updatedUser - Datos actualizados del usuario
 * @returns {Promise<Object|false>} Datos del usuario editado o false si hay error
 */
export const editUserData = async (currentScreenId, typeConnect, updatedUser) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
    ...updatedUser,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.error("Error al editar usuario:", response.data.message);
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Elimina un usuario
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} typeConnect - Tipo de conexión
 * @param {string} usuarioSelected - Usuario seleccionado para eliminar
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const deleteNewUser = async (currentScreenId, typeConnect, usuarioSelected) => {
  const queryData = {
    query_type: currentScreenId,
    action: typeConnect,
    usuarioSelected,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.error("Error al eliminar usuario:", response.data.message);
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Login mediante payload de enlace (link cifrado desde correo).
 * El backend descifra, valida y devuelve token + usuario + MO.
 * @param {string} payload - Cadena cifrada (query param "d" de la URL)
 * @returns {Promise<Object|false>} { status, token, data, mo } o false si hay error
 */
export const loginWithLinkPayload = async (payload) => {
  const body = {
    screen: "auth",
    action: "link-login",
    payload,
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(body), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (response.data.status === "ok") {
      if (response.data.data?.[0]?.lang) {
        Cookies.set("lang", response.data.data[0].lang);
      }
      return response.data;
    }

    // Devolver la respuesta para que el front pueda mostrar message del backend
    return response.data;
  } catch (error) {
    console.error("Error en login con enlace:", error);
    return {
      status: "error",
      message: error.response?.data?.message || error.message || "Error de conexión",
    };
  }
};

/**
 * Autentica con token
 * @param {string} token - Token de autenticación
 * @param {number} currentScreenId - ID de la pantalla actual
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const loginAuthenticateWithToken = async (token, currentScreenId) => {
  const queryData = {
    query_type: currentScreenId,
    token: token,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error al validar el token:", error);
    return false;
  }
};

/**
 * Autentica usuario de calidad
 * @param {string} query_type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Object|false>} Datos de respuesta o false si hay error
 */
export const UserAuthQuality = async (query_type) => {
  const userData = {
    screen: "auth",
    action: "get_user_auth_quality",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(userData), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    if (response.data.status === "ok") {
      return response.data.data; // Asegúrate de devolver los datos correctos
    } else {
      console.log("Error en lista de usuario AuthQuality");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
